/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import CategoriesList from "examples/Lists/CategoriesList";
import categoriesListData from "layouts/pages/widgets/data/categoriesListData";


// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function PlatformSettings() {
  const [followsMe, setFollowsMe] = useState(true);
  const [answersPost, setAnswersPost] = useState(false);
  const [mentionsMe, setMentionsMe] = useState(true);
  const [newLaunches, setNewLaunches] = useState(false);
  const [productUpdate, setProductUpdate] = useState(true);
  const [newsletter, setNewsletter] = useState(true);

  return (
    <Card>
      <SoftBox pt={3} px={2} pl={3}>
        <SoftTypography variant="h5" fontWeight="medium" textTransform="capitalize">
          Tutorials
        </SoftTypography>
      </SoftBox>
      <SoftBox pt={0} pl={3}>
        <SoftTypography variant="h6" color="text" >
          Learn how to use optimind-ai as a professional. 
        </SoftTypography>
      </SoftBox>
      
      <SoftBox >
        <CategoriesList categories={categoriesListData} />
      </SoftBox>
    </Card>
  );
}

export default PlatformSettings;
